export const CookiesEvents = {
  set: 'cookiesEvents/set',
  update: 'cookiesEvents/update',
} as const;

export const COOKIES_STORE_NAME = 'cookies' as const;
